module.exports = __webpack_public_path__ + "static/FSRIwordmark-white-3908d8e72a1cdad9260140fde9369413.png";